import React, { FC, useState, useCallback, useContext } from 'react'
import TinyButton from '../widgets/TinyButton'
import useEditorActions from './useEditorActions'
import icons from '../../icons'

import RenderContext from '@kaidam/fc-shared/src/layout/RenderContext'
import EditorContext from './EditorContext'

import {
  ILayout,
  ILayout_Options,
} from '@kaidam/fc-shared/src/types/layout'

import Window from '../dialog/Window'
import LayoutPreview from './LayoutPreview'

const ViewIcon = icons.view

interface PreviewButtonProps {
  className?: string,
  options: ILayout_Options,
}

const PreviewButton: FC<React.PropsWithChildren<PreviewButtonProps>> = ({
  className,
}) => {

  const [ layoutData, setLayoutData ] = useState<ILayout | null>(null)

  const renderContext = useContext(RenderContext)
  const editorContext = useContext(EditorContext)

  const {
    exportLayout,
  } = useEditorActions()

  const onOpen = useCallback(() => {
    setLayoutData(exportLayout(editorContext.options))
  }, [])

  const onClose = useCallback(() => {
    setLayoutData(null)
  }, [])

  return (
    <>
      <TinyButton
        className={ className }
        onClick={ onOpen }
      >
        Preview
      </TinyButton>
      {
        layoutData && (
          <Window
            open
            size="md"
            fullHeight
            onCancel={ onClose } 
            withCancel
            cancelTitle="Close"
          >
            <LayoutPreview
              data={ layoutData }
              context={ renderContext }
            />
          </Window>
        )
      }
    </>
  )

}

export default PreviewButton